/**
 * Bennji Modern Features JavaScript
 * State-of-the-art interactive features and enhancements
 */

(function() {
  'use strict';

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ============================================
  // 1. ENHANCED MEGA MENU WITH SMOOTH ANIMATIONS
  // ============================================
  function initEnhancedMegaMenu() {
    const menuItems = document.querySelectorAll('.menu-list__list-item');
    
    menuItems.forEach(item => {
      const link = item.querySelector('.menu-list__link');
      const submenu = item.querySelector('.menu-list__submenu');
      
      if (!submenu) return;

      // Add smooth reveal animation
      link.addEventListener('mouseenter', () => {
        if (!prefersReducedMotion) {
          submenu.style.opacity = '0';
          submenu.style.transform = 'translateY(-10px)';
          setTimeout(() => {
            submenu.style.transition = 'opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1), transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
            submenu.style.opacity = '1';
            submenu.style.transform = 'translateY(0)';
          }, 10);
        }
      });

      // Add keyboard navigation
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const firstLink = submenu.querySelector('.mega-menu__link');
          if (firstLink) firstLink.focus();
        }
      });
    });
  }

  // ============================================
  // 2. STICKY HEADER WITH SCROLL EFFECTS
  // ============================================
  function initStickyHeader() {
    const header = document.querySelector('header-component');
    if (!header) return;

    let lastScroll = 0;
    let ticking = false;

    function updateHeader() {
      const scrollY = window.scrollY;
      
      if (scrollY > 100) {
        header.classList.add('header--scrolled');
        if (scrollY > lastScroll && scrollY > 200) {
          header.classList.add('header--hidden');
        } else {
          header.classList.remove('header--hidden');
        }
      } else {
        header.classList.remove('header--scrolled', 'header--hidden');
      }
      
      lastScroll = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  // ============================================
  // 3. PRODUCT CARD ENHANCEMENTS
  // ============================================
  function initProductCardEnhancements() {
    const productCards = document.querySelectorAll('.product-card, [class*="product-card"]');
    
    productCards.forEach(card => {
      // Add quick view on hover (desktop only)
      if (window.innerWidth > 768) {
        card.addEventListener('mouseenter', function() {
          this.style.transform = 'translateY(-4px)';
          this.style.transition = 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
        });
        
        card.addEventListener('mouseleave', function() {
          this.style.transform = 'translateY(0)';
        });
      }

      // Add image lazy loading enhancement
      const images = card.querySelectorAll('img[loading="lazy"]');
      images.forEach(img => {
        img.addEventListener('load', function() {
          this.classList.add('loaded');
        });
      });
    });
  }

  // ============================================
  // 4. SMOOTH SCROLL TO ANCHORS
  // ============================================
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#' || href === '#!') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const headerOffset = 100;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // ============================================
  // 5. INTERSECTION OBSERVER FOR ANIMATIONS
  // ============================================
  function initScrollAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('[data-animate]').forEach(el => {
      observer.observe(el);
    });
  }

  // ============================================
  // 6. ENHANCED SEARCH WITH SUGGESTIONS
  // ============================================
  function initEnhancedSearch() {
    const searchInputs = document.querySelectorAll('input[type="search"], input[name*="search"]');
    
    searchInputs.forEach(input => {
      let debounceTimer;
      
      input.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        const query = this.value.trim();
        
        if (query.length > 2) {
          debounceTimer = setTimeout(() => {
            // Add search suggestions logic here if needed
            this.classList.add('search--active');
          }, 300);
        } else {
          this.classList.remove('search--active');
        }
      });

      // Add keyboard shortcuts
      document.addEventListener('keydown', (e) => {
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
          e.preventDefault();
          input.focus();
        }
      });
    });
  }

  // ============================================
  // 7. CART DRAWER ENHANCEMENTS
  // ============================================
  function initCartDrawerEnhancements() {
    const cartButtons = document.querySelectorAll('[data-cart-toggle], .cart-drawer-toggle');
    
    cartButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Add ripple effect
        const ripple = document.createElement('span');
        ripple.classList.add('ripple-effect');
        this.appendChild(ripple);
        
        setTimeout(() => ripple.remove(), 600);
      });
    });
  }

  // ============================================
  // 8. PERFORMANCE OPTIMIZATIONS
  // ============================================
  function initPerformanceOptimizations() {
    // Preload critical resources
    const criticalImages = document.querySelectorAll('img[data-critical]');
    criticalImages.forEach(img => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = img.src;
      document.head.appendChild(link);
    });

    // Lazy load non-critical images
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            imageObserver.unobserve(img);
          }
        });
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }

  // ============================================
  // 9. ACCESSIBILITY ENHANCEMENTS
  // ============================================
  function initAccessibilityEnhancements() {
    // Skip to content link is handled by theme.liquid - no need to create duplicate

    // Focus visible polyfill for better keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        document.body.classList.add('keyboard-navigation');
      }
    });

    document.addEventListener('mousedown', () => {
      document.body.classList.remove('keyboard-navigation');
    });
  }

  // ============================================
  // 10. MODERN MICRO-INTERACTIONS
  // ============================================
  function initMicroInteractions() {
    // Button hover effects
    document.querySelectorAll('.button, button, a.button').forEach(button => {
      button.addEventListener('mouseenter', function() {
        if (!this.classList.contains('button--no-hover')) {
          this.style.transform = 'translateY(-2px)';
        }
      });
      
      button.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0)';
      });
    });

    // Form input focus effects
    document.querySelectorAll('input, textarea, select').forEach(input => {
      input.addEventListener('focus', function() {
        this.parentElement?.classList.add('input-focused');
      });
      
      input.addEventListener('blur', function() {
        this.parentElement?.classList.remove('input-focused');
      });
    });
  }

  // ============================================
  // INITIALIZATION
  // ============================================
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    initEnhancedMegaMenu();
    initStickyHeader();
    initProductCardEnhancements();
    initSmoothScroll();
    initScrollAnimations();
    initEnhancedSearch();
    initCartDrawerEnhancements();
    initPerformanceOptimizations();
    initAccessibilityEnhancements();
    initMicroInteractions();
  }

  // Initialize immediately if DOM is ready
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Re-initialize on Shopify section loads
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

})();

